import {DependenciesItemChunk} from "../chunks/types/DependenciesItemChunk";
import {DependencyDef} from "./types/DependencyDef";
import {getStringFromStringChunk} from "./utils/getStringFromStringChunk";

export function dependenciesItemChunkToDependencyDef(
  dependenciesItemChunk: DependenciesItemChunk
): DependencyDef {
  const {
    captures: {
      1: stringChunk
    }
  } = dependenciesItemChunk;
  return {
    name: getStringFromStringChunk(stringChunk)
  };
}
